import './setup';

import { Telemetry } from '@affine/core/components/telemetry';
import { resolvePreferredCloudBaseUrl } from '@affine/core/modules/cloud/preferred-server';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

async function bootstrap() {
  await resolvePreferredCloudBaseUrl();
  const { App } = await import('./app');
  // oxlint-disable-next-line typescript/no-non-null-assertion
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <StrictMode>
      <Telemetry />
      <App />
    </StrictMode>
  );
}

void bootstrap().catch(err => {
  console.error('Failed to bootstrap app', err);
});
